import ResearchHome from "../components/home/ResearchHome";
import ImageHeading from "../components/ui/ImageHeading";
import headerImage from "../assets/header/header.jpeg";
import useAxiosPublic from "../hooks/useAxiosPublic";
import { useQuery } from "@tanstack/react-query";
import LoadingPage from "../components/Layout/LoadingPage";
const School = () => {
  const axiosPublic = useAxiosPublic();

  const {
    data: academicsApiData,
    isLoading,
    error,
  } = useQuery({
    queryKey: ["academicsData"],
    queryFn: async () => {
      const res = await axiosPublic.get("/academics");
      return res?.data?.data;
    },
  });
  console.log(academicsApiData);
  if (isLoading) {
    return <LoadingPage />;
  }

  if (error) {
    return (
      <div className="text-center py-20 text-red-500">Error loading data</div>
    );
  }
  return (
    <div>
      <ImageHeading heading={"All Schools"} imageUrl={headerImage} />
      <div className=" py-12">
        <ResearchHome schools={academicsApiData?.academics} />
      </div>
    </div>
  );
};

export default School;
